<template>
  <div class="dg-title" :class="{ 'line': line }">
    <span class="t-[16]  t-[#303133] txt">
      <slot></slot>
    </span>
    <slot name="tip"></slot>
  </div>
</template>
<script>
export default {
  name: 'dg-title',
  data() {
    return {}
  },
  props: {
    line: Boolean
  },
  methods: {},
  mounted() { },
  created() { },
}
</script>
<style lang="less" scoped>
// @import '~@/assets/css/var.less';
.dg-title {
  position: relative;

  // padding: 16px 0;
  &.line::before {
    content: '';
    display: block;
    height: 1px;
    background: #EEEEEE;
    position: absolute;
    left: 10px;
    bottom: 0;
    right: 0;

  }

  .txt {
    position: relative;
    padding-left: 10px;
    line-height: 21px;
    &::after {
      content: '';
      display: block;
      width: 2px;
      height: 15px;
      background: @theme;
      position: absolute;
      left: 0;
      top: 4px;
    }
  }

}
</style>
